<template>
  <Modal
    width="920"
    title="创意组件选择"
    class-name="vertical-center-modal"
    v-model="state"
    :mask-closable="false"
    :closable="false"
    @on-ok="asyncSelect"
    @on-visible-change="bindGetData"
  >
    <Spin size="large" fix v-if="!show"></Spin>
    <Row class="filter-box" :gutter="12" v-if="state">
      <Col span="24">
        <Form inline>
          <FormItem>
            <Input v-model="keyword" placeholder="请输入组件名称或者ID" search @on-search="getData" />
          </FormItem>
          <FormItem>
            <el-select
              v-model="status"
              :popper-append-to-body="false"
              placeholder="审核状态"
              style="width: 150px"
              size="small"
              filterable
              multiple
              clearable
              collapse-tags
            >
              <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </FormItem>
          <FormItem>
            <el-select
              v-model="component_types"
              :popper-append-to-body="false"
              placeholder="组件类型"
              style="width: 180px"
              size="small"
              filterable
              multiple
              clearable
              collapse-tags
            >
              <el-option v-for="item in componentTypeList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </FormItem>
          <FormItem>
            <Button @click="getData">查询</Button>
          </FormItem>
          <div class="pull-right">
            <Button type="primary" @click="newCard">新建卡片</Button>
          </div>
        </Form>
      </Col>
    </Row>
    <Table height="440" stripe highlight-row :columns="columns" :data="creatCompDataList" @on-current-change="bindCurrentRow">
      <template slot-scope="{ row }" slot="status">
        <span>{{ row.status | statusFormat }}</span>
      </template>
      <template slot-scope="{ row }" slot="cardPreview">
        <Card class="card-box">
          <img :src="row.component_data.image_url" class="card-img" />
          <div class="card-info">
            <Tooltip trigger="hover" :content="row.component_data.title" placement="top-start" max-width="600" transfer>
              <span class="tool-span">{{ row.component_data.title }}</span>
            </Tooltip>
            <Tooltip
              trigger="hover"
              :content="row.component_data.product_selling_points.join(',')"
              placement="top-start"
              max-width="600"
              transfer
            >
              <span class="tool-span sub-title">{{ row.component_data.product_selling_points.join(',') }}</span>
            </Tooltip>
          </div>
          <div class="card-button">
            <div class="fake-button">{{ row.component_data.button_text }}</div>
          </div>
        </Card>
        <!-- <span>{{ row.status | statusFormat }}</span> -->
      </template>
      <template slot-scope="{ row }" slot="operation">
        <el-button type="text" size="small" @click="editCard(row)">编辑</el-button>
      </template>
    </Table>

    <!-- 新建卡片 -->
    <add-card
      v-model="addCardModel"
      :info="editCardInfo"
      :loading="addLoading"
      :game-id="gameId"
      @on-create="addCard"
      @on-edit="updateCard"
    ></add-card>
  </Modal>
</template>
<script>
import { creativeCompList, addCreativeCard, UpdateCreativeCard } from '@/api/toutiao.model'
import addCard from './add-card'
import columns from './columns.json'
import { trim } from '@/common/js/utils'
export default {
  name: 'creativeData',
  components: { addCard },
  props: {
    value: {
      type: Boolean
    },
    account: {
      type: [Number, String]
    },
    gameId: {
      type: [Number, String],
      default() {
        return ''
      }
    }
  },
  filters: {
    statusFormat(val) {
      if (val === 'PASS') return '通过'
      else if (val === 'UNDER') return '审核中'
      else if (val === 'REJECT') return '未通过'
      else return '——'
    }
  },
  computed: {
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    // 请求数据
    getData() {
      this.show = false
      creativeCompList({
        ad_account_id: this.account,
        keyword: trim(this.keyword),
        component_types: this.component_types,
        status: this.status
      }).then((data) => {
        this.show = true
        if (data) {
          this.creatCompDataList = data
        }
      })
    },
    newCard() {
      this.editCardInfo = Object.assign({})
      this.addCardModel = true
    },
    addCard(cardInfo) {
      const { component_name, image_id, title, button_text, product_selling_points, enable_personal_action } = cardInfo
      const params = {
        ad_account_id: this.account,
        component_info: {
          component_name,
          component_type: 'PROMOTION_CARD',
          component_data: {
            image_id,
            title,
            button_text,
            product_selling_points,
            enable_personal_action
          }
        }
      }
      this.addLoading = true
      addCreativeCard(params).then((data) => {
        if (data) {
          this.addLoading = false
          this.addCardModel = false
          this.getData()
        } else {
          this.$Message.error('接口请求失败，新建卡片失败')
        }
      })
    },
    updateCard(cardInfo) {
      const { component_name, image_id, title, button_text, product_selling_points, enable_personal_action } = cardInfo
      const { component_id } = this.editCardInfo
      const params = {
        ad_account_id: this.account,
        component_id,
        component_info: {
          component_name,
          component_type: 'PROMOTION_CARD',
          component_data: {
            image_id,
            title,
            button_text,
            product_selling_points,
            enable_personal_action
          }
        }
      }
      this.addLoading = true
      UpdateCreativeCard(params).then((data) => {
        if (data) {
          this.addLoading = false
          this.addCardModel = false
          this.getData()
        } else {
          this.$Message.error('接口请求失败，修改卡片失败')
        }
      })
    },
    bindGetData(val) {
      if (val) {
        this.getData()
      } else {
        this.currentRow = undefined
      }
    },
    // 选中当前项
    bindCurrentRow(currentRow) {
      this.currentRow = currentRow
    },
    editCard(row) {
      const { component_name, component_data, component_id } = row
      const { image_id, title, product_selling_points, button_text, image_url, enable_personal_action } = component_data
      this.editCardInfo = Object.assign({
        component_name,
        image_id,
        title,
        product_selling_points,
        button_text,
        image_url,
        enable_personal_action,
        component_id
      })
      this.addCardModel = true
    },
    asyncSelect() {
      if (!this.currentRow) {
        this.$Message.warning('您未选择一个创意组件')
        return false
      }
      this.$emit('on-select', this.currentRow)
    }
  },
  data() {
    return {
      show: null, // 请求状态
      keyword: null,
      columns: columns,
      addCardModel: false, // 新建卡片弹窗
      creatCompDataList: [],
      addLoading: false,
      editCardInfo: {}, // 编辑卡片反显信息
      statusList: [
        { id: 'PASS', name: '通过' },
        { id: 'UNDER', name: '审核中' },
        { id: 'REJECT', name: '未通过' }
      ],
      componentTypeList: [
        { id: 'CHOICE_MAGNET', name: '选择磁贴' },
        { id: 'VOTE_MAGNET', name: '投票磁贴' },
        { id: 'IMAGE_MAGNET', name: '图片磁贴' },
        { id: 'COMMERCE_MAGNET', name: '电商磁贴' },
        { id: 'COUPON_MAGNET', name: '优惠券磁贴' },
        { id: 'GAME_PACK', name: '游戏礼包码' },
        { id: 'PROMOTION_CARD', name: '推广卡片' }
      ],
      status: [], // 审核状态
      component_types: [] // 组件类型
    }
  }
}
</script>
<style lang='scss' scoped>
.filter-box {
  margin-bottom: 15px;

  ::v-deep .ivu-form-item {
    margin-bottom: 0;
  }
}

.card-box {
  height: 60px;
  margin: 5px 0;
  position: relative;
  display: block;
  background: #f2f2f2;

  .card-img {
    position: absolute;
    height: 100%;
    top: 0;
    left: 20px;
    padding: 8px;
  }

  .card-info {
    position: absolute;
    width: 35%;
    height: 100%;
    top: 0;
    padding: 8px;
    left: 70px;

    .tool-span {
      width: 90px;
      font-weight: bold;
      display: inline-block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .sub-title {
      font-size: 8px;
      font-weight: normal;
    }
  }

  .card-button {
    position: absolute;
    right: 0;
    top: 0;
    width: 40%;
    height: 100%;
    padding: 13px;

    .fake-button {
      background: #409eff;
      height: 100%;
      color: #fff;
      text-align: center;
      line-height: 32px;
      border-radius: 5px;
    }
  }
}
</style>
